import React, { useCallback, useEffect, useState } from 'react'
import Toast, { showToast } from '../../Components/Toast';
import Header from './Header';
import Add from './Add';
import Edit from './Edit';
import Loader from '../../Components/Loader';
import Table from '../../Components/Table';
import { EuiImage, EuiPageBody } from '@elastic/eui';
import axios from '../../axiosService';
import ConfirmModel, { showDialog, hideDialog } from '../../Components/ConfirmModel'
import moment from "moment";

function CommitteeDetails() {
  const server = process.env.REACT_APP_APIPATH
  const authtoken = localStorage.getItem("authtoken");
  const config = {
    headers: {
      'Authorization': "Bearer " + authtoken
    }
  }

  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [EditData, setEditData] = useState({});

  const [IsLoading, setIsLoading] = useState(false)
  const startLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  const [Data, setData] = useState([])

  const columns = [
    { field: 'rowNumber', name: 'Row Number', sortable: true },
    { field: 'committeeMemberName', name: 'Name', sortable: true },
    { field: 'address', name: 'Address', sortable: true },
    { field: 'mobileNo', name: 'Mobile No', sortable: true },
    { field: 'emailId', name: 'Email ID', sortable: true },
    { field: 'designation', name: 'Designation', sortable: true },
    { field: 'description', name: 'Description', sortable: true },
    {
      field: 'dob', name: 'DOB', sortable: true, render: (dob) => (
        <span>{new Date(dob).toLocaleDateString("in", {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        })}</span>
      )
    },
    {
      field: 'dateOfJoining', name: 'Date Of Joining', sortable: true, render: (dateOfJoining) => (
        <span>{new Date(dateOfJoining).toLocaleDateString("in", {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        })}</span>
        )
    },
    {
      field: 'photo', name: 'Image', render: (photo) => (
        <EuiImage size="m" src={server + photo} alt='No Image Found' allowFullScreen hasShadow />
      )
    }
  ]

  // delete function
  const deleteRecord = async (record) => {
    try {
      startLoading();
      const response = await axios.delete(`${server}api/Committee/` + record.committeeMemberId, config);
      if (response.status === 200) {
        filldata()
        showToast("Record Deleted", "success", 2000);
      }
      stopLoading();
      hideDialog();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      stopLoading();
    }
  };

  // edit function
  const editRecord = async (record) => {
    try {
      startLoading();
      const response = await axios.get(`${server}api/Committee/` + record.committeeMemberId, config)
      if (response.status === 200) {
        const data = await response.data;
        setEditData({ ...data, dob: moment.utc(data.dob), dateOfJoining: moment.utc(data.dateOfJoining) });
        setIsEditing(true);
      }
      stopLoading();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      console.error(error);
      stopLoading();
    }
  };

  //declare edit and delete buttons
  const actions = [
    {
      name: 'Edit',
      isPrimary: true,
      description: 'Edit this Record',
      icon: 'pencil',
      type: 'icon',
      onClick: editRecord,
      'data-test-subj': 'action-edit',
    }, {
      name: "Delete",
      description: 'Delete this Record',
      icon: 'trash',
      color: 'danger',
      type: 'icon',
      onClick: showDialog,
      isPrimary: true,
      'data-test-subj': 'action-delete',
    }
  ];

  //add buttons to columns
  const columnsWithActions = [
    ...columns,
    {
      name: 'Actions',
      actions,
    },
  ];

  //get table data
  const filldata = async () => {
    try {
      startLoading();
      const response = await axios.get(`${server}api/Committee`, config);
      if (response.status === 200) {
        const data = await response.data;
        setData(data);
      }
      stopLoading();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      stopLoading();
    }
  }

  useEffect(() => {
    filldata();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!isEditing && !isAdding) {
      filldata()
    }
    // eslint-disable-next-line
  }, [isAdding, isEditing]);

  useEffect(() => {
    if (!isEditing) {
      setEditData({});
    }
  }, [isEditing]);

  return (
    <EuiPageBody style={{ width: "100%", padding: "10px" }}>
      <Loader IsLoading={IsLoading} />
      {!isAdding && !isEditing && (
        <>
          <Header
            headerText="Committee Member Details"
            setIsAdding={setIsAdding}
          />
          <Table data={Data} columns={columnsWithActions} height={70} />
        </>
      )}
      {isAdding && (
        <Add
          server={server}
          authtoken={authtoken}
          startLoading={startLoading}
          stopLoading={stopLoading}
          setIsAdding={setIsAdding}
        />
      )}
      {isEditing && (
        <Edit
          server={server}
          authtoken={authtoken}
          EditData={EditData}
          startLoading={startLoading}
          stopLoading={stopLoading}
          setIsEditing={setIsEditing}
        />
      )}
      <Toast />
      <ConfirmModel title="Delete Record ?" text="The Record will be Deleted. Please Proceed With Caution !" confirmButton="Delete" cancelButton="Cancel" confirmFunction={deleteRecord} />
    </EuiPageBody>
  )
}

export default CommitteeDetails
